import classNames from 'classnames'
import React, { PropsWithChildren } from 'react'

import { Tooltip } from '@ui/components/Tooltip/Tooltip'

import { useCopy } from '@hooks/useCopy'

import styles from './CopyLink.module.scss'

interface Props {
  value?: string | number
  label?: string
  onCopy?: () => void
  tooltip?: string
  wrapperClassName?: string
  preventClick?: boolean
}

export const CopyLink: React.FunctionComponent<PropsWithChildren<Props>> = ({
  value,
  children,
  label,
  tooltip,
  onCopy,
  wrapperClassName,
  preventClick,
}) => {
  const { copy } = useCopy()

  const handleOnClick = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    if (preventClick) return
    e.stopPropagation()
    copy(value, label)
    onCopy?.()
  }

  return (
    <Tooltip content={tooltip} disabled={!tooltip} wrapperClassName={wrapperClassName}>
      <span
        className={classNames(styles.wrapper, { [styles.notClickable]: preventClick })}
        onClick={handleOnClick}
      >
        {children}
      </span>
    </Tooltip>
  )
}
